import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const VendorSlider = () => {
    return (
        <div className="vendor-slider-wrapper">
            <h2 className="vendor-slide-title text-center">مزایای فروش در سایمان دیجیتال</h2>
            <div className="container container-vendor-slider">
                <div className="swiper vendor-slider-swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4380.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4381.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4382.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4383.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4384.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4385.png" alt="asdfds"/>
                        </div>
                        <div className="swiper-slide">
                            <img src="./assets/vendorImages/Group 4413.png" alt="asdfds"/>
                        </div>
                    </div>
                    <div className="buttons-navigate position-absolute">
                        <span className="swiper-button-prev-vendor buttons xmt-1"><IconName name="chevron_left" className="icon"/></span>
                        <span className="swiper-button-next-vendor buttons"><IconName name="chevron_left" className="icon"/></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorSlider;
